import { render, staticRenderFns } from "./yaozhui-yatongdian-left.vue?vue&type=template&id=72ea3a50&scoped=true&"
import script from "./yaozhui-yatongdian-left.vue?vue&type=script&lang=ts&"
export * from "./yaozhui-yatongdian-left.vue?vue&type=script&lang=ts&"
import style0 from "./yaozhui-yatongdian-left.vue?vue&type=style&index=0&id=72ea3a50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ea3a50",
  null
  
)

export default component.exports